module.exports = __webpack_public_path__ + "static/media/dealer-background-image-min.6174a13c.jpg";